/* TODO: should be throwing on errors so that we have a stack trace */
/* eslint-disable prefer-promise-reject-errors */

import 'isomorphic-fetch';

export const genericError = {
  message: 'Something went wrong, please try again later',
};

// Helper promise to check status of a response
export const checkResponse = (response) =>
  new Promise((resolve, reject) => {
    if (response.ok) {
      resolve(response);
    } else {
      // Fetch was made successfully, but response was bad
      reject(response);
    }
  });

// Resolve reponse body to JSON object or text promise
export const parseResponse = (response) => {
  const contentType = response.headers && response.headers.get('Content-Type');
  if (
    contentType &&
    contentType.includes('application/json') &&
    // Because https://httpstatuses.com/204 cannot contain a body,
    // attempting to JSON.parse the empty '' will throw an error
    response.status !== 204
  ) {
    return response.json();
  }
  return response.text();
};

// Error response may be a JSON object or something unexpected
export const parseErrorResponse = (errorResponse) => {
  // Decorate generic error with response status
  const statusError = { ...genericError, status: errorResponse.status };
  return new Promise((resolve, reject) => {
    errorResponse
      .json()
      .then((jsonError) => {
        // Well-formed JSON error merge
        reject({ ...statusError, ...jsonError });
      })
      .catch(() => {
        // Could not parse response as JSON
        reject(statusError);
      });
  });
};

// Fetch failed, e.g. preflight CORS or bad URL
export const handleFetchError = (error) =>
  Promise.reject({ ...genericError, message: error.message });

// Handle fetch JSON responses
export const handleResponse = (response) =>
  checkResponse(response)
    .then(parseResponse)
    .catch(parseErrorResponse);

// Isomorphic fetch GET with JSON helper functions
export const fetchJSON = (url, headers = {}) =>
  fetch(url, { headers })
    .catch(handleFetchError)
    .then(handleResponse);

// Isomorphic fetch POST with JSON helper functions
export const postJSON = (url, headers = {}, body) =>
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify(body),
  })
    .catch(handleFetchError)
    .then(handleResponse);
